import { render, staticRenderFns } from "./ZoneDetails.vue?vue&type=template&id=37cde79e&scoped=true"
import script from "./ZoneDetails.vue?vue&type=script&lang=js"
export * from "./ZoneDetails.vue?vue&type=script&lang=js"
import style0 from "./ZoneDetails.vue?vue&type=style&index=0&id=37cde79e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cde79e",
  null
  
)

export default component.exports